import { styled } from '@mui/material/styles'
import RoundChatIcon from '../../../../components/icons/RoundChatIcon'
import { ActiveHeaderIconButton } from './common'
import { colorPalette } from '../../../../style/colorPalette'

interface DiscussionButtonProps {
  isOpen: boolean
  disabled?: boolean
  onToggle: () => void
}

const StyledChatIcon = styled(RoundChatIcon)<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    height: '17px',
    verticalAlign: 'middle',
    margin: 0,
    cursor: 'pointer',
    color: isOpen ? colorPalette.monotone[0] : colorPalette.monotone[4],
    fill: isOpen ? colorPalette.monotone[0] : 'none',
    transition: theme.transitions.create(['color', 'fill'], {
      duration: theme.transitions.duration.short,
    }),
  })
)

export const DiscussionButton = ({
  isOpen,
  disabled,
  onToggle,
}: DiscussionButtonProps) => {
  return (
    <ActiveHeaderIconButton
      active={isOpen}
      disabled={disabled}
      onClick={onToggle}
    >
      <StyledChatIcon isOpen={isOpen} />
    </ActiveHeaderIconButton>
  )
}
